module.exports = __webpack_public_path__ + "7e4ee030810dee153412fa25d3baca11.svg";